<ng-container>
  <button
    mat-button
    disableRipple="true"
    class="main-toolbar-button"
    [matMenuTriggerFor]="reportMenu"
    [disabled]="!hasExportSelected(projectEntity$ | async)"
  >
    {{ 'UI.Common.Action.Export' | translate }}
  </button>

  <mat-menu #reportMenu="matMenu" xPosition="before" class="export-menu">
    <button mat-menu-item class="export-button" (click)="getReportProject('pdf')">
      {{ 'UI.Common.Action.GetProjectPDF' | translate }}
    </button>
    <button mat-menu-item class="export-button" (click)="getReportProject('docx')">
      {{ 'UI.Common.Action.GetProjectDOCX' | translate }}
    </button>
    <!-- <button mat-menu-item (click)="getReportQuotation('pdf')">{{ 'UI.Common.Action.GetQuotationPDF' | translate }}</button> -->
    <!-- <button mat-menu-item (click)="getReportQuotation('docx')">{{ 'UI.Common.Action.GetQuotationDOCX' | translate }}</button> -->
    <button mat-menu-item class="export-button" (click)="getReportDrawings('pdf')">
      {{ 'UI.Common.Action.GetDrawingsPDF' | translate }}
    </button>
    <button mat-menu-item class="export-button" (click)="getReportDrawings('docx')">
      {{ 'UI.Common.Action.GetDrawingsDOCX' | translate }}
    </button>
    <!-- <button mat-menu-item (click)="getReportBOM()">{{ 'UI.Common.Action.GetReportBOM' | translate }}</button> -->
    <button mat-menu-item class="export-button" (click)="getDxf()">{{ 'UI.Common.Action.GetDrawingsDXF' | translate }}</button>
    <button *ngIf="canAccessPrices$ | async" mat-menu-item class="export-button" (click)="getReportArticleNumbers()">
      {{ 'UI.Common.Action.GetReportArticleNumbers' | translate }}
    </button>
    <button *ngIf="isAdmin$ | async" mat-menu-item class="export-button" (click)="exportToMagiCAD()">
      {{ 'UI.Common.Action.GetMagiCADMcHoodProject' | translate }}
    </button>
    <button *ngIf="isAdmin$ | async" mat-menu-item class="export-button" (click)="exportToXml()">
      {{ 'UI.Common.Action.GetProjectXML' | translate }}
    </button>
    <button mat-menu-item class="export-button" (click)="getAllDocuments()">{{ 'UI.Common.Action.GetAllDocuments' | translate }}</button>
  </mat-menu>
</ng-container>
